import { useState } from 'react';
import { supabase } from '../../../lib/supabase';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    taxId: '',
    type: '需求方',
    amount: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      // 構建完整的訊息內容
      const fullMessage = `公司：${formData.company}
公司統編：${formData.taxId}
身份：${formData.type}
資金金額：${formData.amount || '未提供'}

${formData.message}`;

      // 直接存入 Supabase 資料庫
      const { error } = await supabase
        .from('contact_submissions')
        .insert([
          {
            name: formData.name,
            phone: formData.phone,
            email: formData.email || '未提供',
            message: fullMessage
          }
        ]);

      if (error) throw error;

      setSubmitStatus('success');
      setFormData({
        name: '',
        company: '',
        phone: '',
        email: '',
        taxId: '',
        type: '需求方',
        amount: '',
        message: ''
      });
    } catch (error) {
      console.error('提交失敗:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">聯絡我們</h2>
          <div className="w-20 h-1 bg-[#1a5f7a] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            歡迎透過以下方式與我們聯繫，我們將盡快為您提供專業的資金媒合服務
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">聯絡資訊</h3>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#1a5f7a]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#1a5f7a]"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-1">電話諮詢</h4>
                    <p className="text-gray-600">02-27951331</p>
                    <p className="text-sm text-gray-500 mt-1">週一至週五 09:00-18:00</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#1a5f7a]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#1a5f7a]"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-1">電子郵件</h4>
                    <p className="text-gray-600">contact@psfcapital.tw</p>
                    <p className="text-sm text-gray-500 mt-1">24小時內回覆</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#1a5f7a]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-[#1a5f7a]"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-1">辦公地址</h4>
                    <p className="text-gray-600">台北市內湖區行善路385號</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#1a5f7a]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-fill text-xl text-[#1a5f7a]"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-bold text-gray-900 mb-1">LINE 官方帳號</h4>
                    <a
                      href="https://line.me/R/ti/p/@678gwbht"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#1a5f7a] hover:text-[#164d61] font-medium mb-2 block cursor-pointer"
                    >
                      @678gwbht
                    </a>
                    <a
                      href="https://line.me/R/ti/p/@678gwbht"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-[#1a5f7a] hover:text-[#164d61] font-medium text-sm cursor-pointer"
                    >
                      立即加入
                      <i className="ri-arrow-right-line ml-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#1a5f7a] to-[#2a7a9a] rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">為什麼選擇 LINE 諮詢？</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 flex-shrink-0 mt-0.5"></i>
                  <span>即時回應，快速解答您的疑問</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 flex-shrink-0 mt-0.5"></i>
                  <span>方便傳送文件與資料</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 flex-shrink-0 mt-0.5"></i>
                  <span>保留完整對話記錄</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-xl mr-2 flex-shrink-0 mt-0.5"></i>
                  <span>專業顧問一對一服務</span>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">線上諮詢表單</h3>

              <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    姓名 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                    placeholder="請輸入您的姓名"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    公司名稱 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="company"
                    required
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                    placeholder="請輸入公司名稱"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      聯絡電話 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                      placeholder="0912-345-678"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      電子郵件
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                      placeholder="example@email.com"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    公司統編 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="taxId"
                    required
                    value={formData.taxId}
                    onChange={(e) => setFormData({ ...formData, taxId: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                    placeholder="12345678"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    身份類型 <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="type"
                    required
                    value={formData.type}
                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm cursor-pointer"
                  >
                    <option value="需求方">需求方（尋求資金）</option>
                    <option value="資金方">資金方（提供資金）</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    資金需求/投資金額
                  </label>
                  <input
                    type="text"
                    name="amount"
                    value={formData.amount}
                    onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent text-sm"
                    placeholder="例如：3,000萬"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    詳細說明 <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1a5f7a] focus:border-transparent resize-none text-sm"
                    placeholder="請簡述您的需求或投資意向（限500字）"
                  ></textarea>
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.message.length}/500
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl mr-3 flex-shrink-0"></i>
                    <div>
                      <p className="text-green-800 font-medium">送出成功！</p>
                      <p className="text-green-700 text-sm mt-1">我們已收到您的諮詢，將於 24 小時內與您聯繫。</p>
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start">
                    <i className="ri-error-warning-fill text-red-500 text-xl mr-3 flex-shrink-0"></i>
                    <div>
                      <p className="text-red-800 font-medium">送出失敗</p>
                      <p className="text-red-700 text-sm mt-1">請稍後再試，或直接透過 LINE 與我們聯繫。</p>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#1a5f7a] text-white py-4 rounded-lg font-semibold hover:bg-[#164d61] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? '送出中...' : '送出諮詢'}
                </button>

                <p className="text-xs text-gray-500 text-center">
                  送出表單即表示您同意我們的隱私權政策。我們將妥善保管您的個人資料。
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
